import { render, staticRenderFns } from "./RegisterPasswordStep.vue?vue&type=template&id=745a8103&scoped=true&"
import script from "./RegisterPasswordStep.vue?vue&type=script&lang=js&"
export * from "./RegisterPasswordStep.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPasswordStep.vue?vue&type=style&index=0&id=745a8103&lang=scss&scoped=true&"
import style1 from "./RegisterPasswordStep.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745a8103",
  null
  
)

export default component.exports